var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var PropTypes = require('prop-types');
var Callout = require('../../components/callout.jsx');
var RegisterBox = require('../../components/registerBox.jsx');

var Register = createReactClass({
	mixins: [PureRenderMixin],

	componentDidMount: function(){
		this.unlisten = this.context.router.listen(function(location){
			if(location.pathname !== this.props.location.pathname && location.pathname !== '/login'){
				this.props.clearLoginRedirectUrl();
			}
		}.bind(this));
    },

    componentWillUnmount: function(){
        this.props.clearRegError();
		this.unlisten();
    },

    render: function(){
    	var regError = this.props.auth.error;
        return (
			<div className="content">
			    <Helmet title='Register' />
	            <div className="row">
                    {Object.keys(regError).length !== 0 &&
    		            <Callout type="alert" message={regError.message ? regError.message : regError.toString()} handleClose={this.props.clearRegError} />
    		        }
	                <div className="large-6 small-12 column show-for-large">
						<div className="hero-text-block">
							<h1>Sign Up for MyGiHealth,<br /> and <strong>Get Better</strong></h1>
							<p>Endorsed by the American Gastroentrological Association, the country's top GI doctors and researchers from leading academic institutions have developed the most advanced tools to help you manage your GI conditions, bar none!</p>
						</div>
                    </div>
	                <div className="large-5 small-12 column end">
	                    <RegisterBox
                            signUp={this.props.signUp}
                            loginRedirectUrl={this.props.auth.loginRedirectUrl}
                            authFacebook={this.props.authFacebook}
                            source="Register"
                            recordRegisterClick={this.props.recordRegisterClick} />
						<p className="hide-for-large">
							<a className="download-app" href="http://get.mygihealth.io/downloadtheapp">
								<img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/app-store-badge.png" alt="Download on the App Store" id="app-store-badge" />
							</a>
						</p>
	                </div>
	            </div>
			</div>
        )
    }
});

Register.contextTypes = {
  	router: PropTypes.object.isRequired
};

module.exports = Register;



// WEBPACK FOOTER //
// ./src/common/routes/register/components/register.jsx